// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { windowRestore16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-window-restore': IconWindowRestore;
    }
}

/**
 * The icon component for the 'windowRestore' icon
 */
export class IconWindowRestore extends IconSvg {
    public constructor() {
        super(windowRestore16X16);
    }
}

registerIconSvg('icon-window-restore', IconWindowRestore);
export const iconWindowRestoreTag = 'nimble-icon-window-restore';
